import { gql } from '@apollo/client'

export const userHashtagRemoveMany = gql`
  mutation UserHashtagRemoveMany($hashtags: [String!]!) {
    userHashtagRemoveMany(hashtags: $hashtags)
  }
`
